module.exports = __webpack_public_path__ + "static/media/Billboard.9e60c4ad.jpeg";